export default "__VITE_ASSET__CJUSG$Bx__"